module.exports = __webpack_public_path__ + "static/Navegando-d0b79c4bb20cb47b16fab704834f0749.png";